export default {
  existing_documents: {
    description:
      'Hai già caricato i seguenti documenti. Selezionane uno e premi Invia, oppure carica un nuovo documento.',
    sides: {
      front: 'Fronte',
      back: 'Retro',
    },
    created_at: 'Caricato: {{date}}',
    expires_at: 'Scadenza: {{date}}',
  },
  document_types: {
    owner_document: "Documento d'identità del titolare",
    business_document: 'Documento aziendale',
  },
  form: {
    document_type: {
      label: "Documento di prova d'identità",
      placeholder: 'Seleziona tipo di documento',
      options: {
        passport: 'Passaporto',
        driver_license: 'Patente di guida',
        id_card: "Carta d'identità",
        residence_permit: 'Permesso di soggiorno',
      },
    },
    front: {
      label: 'Fronte del documento',
    },
    back: {
      label: 'Retro del documento (facoltativo per alcuni documenti)',
    },
    expires_at: {
      label: 'Data di scadenza del documento',
      placeholder: 'Seleziona la data di scadenza',
    },
  },
  buttons: {
    select_file: 'Seleziona file',
    next: 'Avanti',
    back: 'Retro',
    send: 'Invia',
    upload_new: 'Carica nuovo documento',
    use_existing: 'Usa un documento già caricato',
  },
};
